import { Injectable } from "@angular/core";

import { ProfileService } from "common/services/profile.service";
import {LoginResult} from "digital-core";

@Injectable()
export class AdminAuthorizationGuard  {
    profile: LoginResult;
  constructor(private profileService: ProfileService
  ) { 
      this.profile = this.profileService.getUserProfile();
   }

  public canActivate() { 
  if (this.profile.SystemRole === "_Admin") {
            return true;  
    } 
  } 
}
